module.exports = __webpack_public_path__ + "img/doc.f2eff8bc.svg";